import { RadioButton } from 'lego-on-react';
import React, { useState } from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Monitoring';
import block from 'propmods';

import {
    MonitoringPageAreaChart,
    MonitoringPageAreaChartProps,
} from '../MonitoringPageAreaChart/MonitoringPageAreaChart';

import './MonitoringPageSmartHomeTimings.scss';

const t = i18n(keyset);
const b = block('MonitoringPageSmartHomeTimings');

const options = [
    {
        text: '75%',
        value: '75',
    },
    {
        text: '95%',
        value: '95',
    },
    {
        text: '99%',
        value: '99',
    },
];

export const MonitoringPageSmartHomeTimings: React.FC<MonitoringPageAreaChartProps> = ({ labels, ...restProps }) => {
    const [currentPerc, setCurrentPerc] = useState('75');

    return (
        <div {...b()}>
            <div {...b('percentile')}>
                <span {...b('percentile-label')}>{t('label-percentile')}</span>
                <RadioButton
                    disabled={restProps.dataLoadingState === 'loading'}
                    size="s"
                    theme="normal"
                    value={currentPerc}
                    onChange={(e) => setCurrentPerc(e.target.value)}
                >
                    {options.map(({ text, value }) => {
                        return (
                            <RadioButton.Radio key={value} value={value}>
                                {text}
                            </RadioButton.Radio>
                        );
                    })}
                </RadioButton>
            </div>
            <MonitoringPageAreaChart labels={labels.filter((l) => l.endsWith(currentPerc))} {...restProps} />
        </div>
    );
};
